import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CbreAlertService } from '@cbre/alerts';
import { AssignComponent } from '@shared/dialogs/assign/assign.component';
import { HelpTicket } from '@shared/models/help-ticket.model';
import { ICatalog } from '@shared/models/icommons.model';
import { IUser } from '@shared/models/iuser.model';
import { DialogService } from '@shared/services/dialog.service';
import { SharedService } from '@shared/services/shared.service';

import { take } from 'rxjs/operators';

@Component({
  selector: 'miq-ticket-detail',
  templateUrl: './ticket-detail.component.html',
  styleUrls: ['./ticket-detail.component.scss'],
  standalone: false,
})
export class TicketDetailComponent implements OnInit, OnChanges {
  @Input()
  public ticketDetail: HelpTicket;
  @Input()
  public ticketStatuses: ICatalog[];
  @Input()
  public isProfile: boolean;
  @Input()
  public appCatalogs: ICatalog[] = [];
  @Input()
  public isInGroup: boolean;
  @Input()
  public currentUserInfo: IUser;
  @Output()
  public backToListEvent = new EventEmitter<number>();
  @Output()
  public addAssignTo: EventEmitter<{ ticketId: number; isInGroup: boolean }> = new EventEmitter();

  public users: IUser[];
  public page: string;
  public jiraNumberCtrl = new UntypedFormControl();
  public estimatedReleaseDateCtrl = new UntypedFormControl();

  constructor(
    private notificationService: DialogService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sharedService: SharedService,
    private cbreAlertService: CbreAlertService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.ticketDetail) {
      this.ticketDetail = changes.ticketDetail.currentValue;
      this.page = this.appCatalogs.find(f => f.key === this.ticketDetail.pageId).value;
    }
  }

  ngOnInit() {
    this.sharedService
      .getAdminUsers()
      .pipe(take(1))
      .subscribe(result => (this.users = result));
  }

  assignTo(): void {
    this.notificationService
      .openDialog(
        AssignComponent,
        {
          users: this.users,
          userInfo: this.currentUserInfo,
          ticketInfo: this.ticketDetail,
        },
        { panelClass: 'table-modals' }
      )
      .subscribe(res => {
        if (res && res.ticketInfo) {
          this.ticketDetail.assignedTo = res.ticketInfo.assignedTo;
          this.addAssignTo.emit({ ticketId: this.ticketDetail.id, isInGroup: this.isInGroup });
        }
      });
  }

  backToList() {
    this.backToListEvent.emit(0);
  }

  updateStatus(statusId) {
    const ticketDetail: HelpTicket = {
      id: this.ticketDetail.id,
      statusId: statusId,
      updateBy: `${this.currentUserInfo.firstName} ${this.currentUserInfo.lastName}`,
    };

    this.updateTicket(ticketDetail);
  }

  updateTicket(ticketDetail: HelpTicket) {
    this.sharedService.putTicketDetail(ticketDetail).subscribe(
      () => {
        this.cbreAlertService.showInfoSnackBar_l10n('shared.ticketStatusUpdated');
      },
      () => {
        this.cbreAlertService.showInfoSnackBar_l10n('shared.sorryTicketStatusUpdatedFailed');
      }
    );
  }

  handleJiraNumberEvt(jiraNumberCtrl: UntypedFormControl) {
    this.jiraNumberCtrl = jiraNumberCtrl;
  }

  handleEstimatedReleaseDateEvt(estimatedReleaseDateCtrl: UntypedFormControl) {
    this.estimatedReleaseDateCtrl = estimatedReleaseDateCtrl;
  }

  submit() {
    const ticketDetail: HelpTicket = {
      id: this.ticketDetail.id,
      updateBy: this.currentUserInfo.firstName + ' ' + this.currentUserInfo.lastName,
    };

    if (this.jiraNumberCtrl.dirty) {
      ticketDetail.jiraNumber = this.jiraNumberCtrl.value;
    }

    if (this.estimatedReleaseDateCtrl.dirty) {
      ticketDetail.estimatedReleaseDate = this.estimatedReleaseDateCtrl.value;
    }

    if (this.jiraNumberCtrl.dirty || this.estimatedReleaseDateCtrl.dirty) {
      this.updateTicket(ticketDetail);
    }
  }
}
